/* unplugin-vue-components disabled */import script from "./NumBadge.vue?vue&type=script&setup=true&lang=js"
export * from "./NumBadge.vue?vue&type=script&setup=true&lang=js"

import "./NumBadge.vue?vue&type=style&index=0&id=7bedbefa&lang=scss"

export default script